import { useState } from "react";
import { Dominios, StatusCode } from "../../../utils/enums";
import { getBeneficios, getDestinos, getEjecutivos, getFinalidades, getOperacion, getOrigenes, 
            getTipoProducto, getTipoSubsidio } from "../services/servicesOperacion";
import { beneficio, destino, ejecutivo, finalidad, operacion, origen, tipoProducto, tipoSubsidio } from "../models/operacion";
import { selectorTransversal } from "../../../dtos/selector";
import { getEmisoresTablaDividendo, getValoresDominio } from "../../../services/servicesDominio";
import { AxiosResponse } from "axios";
import { ListResponseDto } from "../../../dtos/ListResponseDto";

export function useOperacion() {
    const [tipoProductos, setTipoProductos] = useState<selectorTransversal[]>([]);
    const [listaDestinos, setListaDestinos] = useState<selectorTransversal[]>([]);
    const [listaEjecutivos, setListaEjecutivos] = useState<selectorTransversal[]>([]);
    const [listaOrigenes, setListaOrigenes] = useState<selectorTransversal[]>([]);
    const [finalidades, setFinalidades] = useState<selectorTransversal[]>([]);
    const [tipoSubsidios, setTipoSubsidios] = useState<selectorTransversal[]>([]);
    const [beneficios, setBeneficios] = useState<selectorTransversal[]>([]);
    const [utilidades, setUtilidades] = useState<selectorTransversal[]>([]);
    const [canalVentas, setCanalVentas] = useState<selectorTransversal[]>([]);
    const [prepagos, setPrepagos] = useState<selectorTransversal[]>([]);
    const [dfl2, setDfl2] = useState<selectorTransversal[]>([]);
    const [adquisicion, setAdquisicion] = useState<selectorTransversal[]>([]);
    const [refinanciamiento, setRefinanciamiento] = useState<selectorTransversal[]>([]);
    const [selectorBaseTasas, setSelectorBaseTasas] = useState<selectorTransversal[]>([]);
    const [emisores, setEmisores] = useState<selectorTransversal[]>([])
    const [defaultValues, setDefaultValues] = useState<operacion>({
        tipoDeudor: '',
        tipoProducto: '',
        destinoCredito: '',
        ejecutivo: null,
        tieneSubsidio: false,
        comisionPrepago: null,
        diaPago: null,
        mesesGraciasK: 0,
        mesesGraciaKI: 0,
        montoUltimoDividendo: 0,
        prepago: '',
        tasaEndoso: 0,
        plazoMaximo: null,
        plazoMinimo: null,
        precioVenta: 0,
        montoCredito: 0,
        montoMutuo: 0,
        tasaEmision: 0,
        pagoContado: 0,
        gastosOperacionales: null,
        esGastosIncluidosCredito: false,
        spread: null,
        finalidadCredito: '',
        dfL2: false,
        utilidad: '',
        origen: '',
        canalVenta: '',
        tipoSubsidio: null,
        tipoBeneficio: '',
        porcentajeDcto: null,
        numeroPropiedades: 0,
        refinanciamiento: null,
        refinancMontoLey: null,
        refinancGenerales: null,
        refinancProvBanco: null,
        refinancDivsFuturosBanco: null,
        adquisicion: null,
        liquidacionPrepagoVendedor: null,
        nombreTablaCuotaMaxima: '',
        tasaTablaCuotaMinima: 0,
        nombreTablaCuotaMinima: '',
        cuotaMinima: 0,
        cuotaMaxima: null,
        codProyecto: '',
        resolucion: '',
        libreta: '',
        serie: '',
        bonoIntegracion: 0,
        bonoCaptacion: 0,
        ahorro: 0,
        codigoBanco: '',
        subsidio: 0

    });

    const listaTipoProducto = async () => {
        const resp :AxiosResponse<ListResponseDto<tipoProducto>> = await getTipoProducto()
        if (resp.status === 200) {
            const data: tipoProducto[] = await resp.data.items;
            let values: selectorTransversal[] = [];
            data.map((x) => values.push({ value: (x.codigo), label: x.descripcion }));
            setTipoProductos(values);
        }

        return;
    }

    const listaDestino = async () => {
        const resp :AxiosResponse<ListResponseDto<destino>>= await getDestinos()
        if (resp.status === 200) {
            const data: destino[] = await resp.data.items;
            let values: selectorTransversal[] = [];
            data.map((x) => values.push({ value: (x.codigo), label: x.descripcion }));
            setListaDestinos(values);
        }

        return;
    }


    const listaEjecutivo = async () => {
        const resp : AxiosResponse<ListResponseDto<ejecutivo>>= await getEjecutivos()
        if (resp.status === 200) {
            const data: ejecutivo[] = await resp.data.items;
            let values: selectorTransversal[] = [];
            data.map((x) => values.push({ value: (x.rut), label: `${x.apellidoPaterno} ${x.apellidoMaterno}, ${x.nombres}` }));
            setListaEjecutivos(values);
        }

        return;
    }

    const listaOrigen = async () => {
        const resp :AxiosResponse<ListResponseDto<origen>>= await getOrigenes()
        if (resp.status === 200) {
            const data: origen[] = await resp.data.items;
            let values: selectorTransversal[] = [];
            data.map((x) => values.push({ value: (x.codigo), label: x.descripcion }));
            setListaOrigenes(values);
        }

        return;
    }

    const listaFinalidad = async () => {
        const resp :AxiosResponse<ListResponseDto<finalidad>>= await getFinalidades()
        if (resp && resp.status === 200) {
            const data: finalidad[] = await resp.data.items;
            let values: selectorTransversal[] = [];
            data.map((x) => values.push({ value: (x.descripcion), label: x.descripcion }));
            setFinalidades(values);
        }

        return;
    }

    const listaTipoSubsidio = async () => {
        const resp :AxiosResponse<ListResponseDto<tipoSubsidio>> = await getTipoSubsidio()
        if (resp.status === 200) {
            const data: tipoSubsidio[] = await resp.data.items;
            let values: selectorTransversal[] = [];
            data.map((x) => values.push({ value: (x.codigo), label: x.codigo }));
            setTipoSubsidios(values);
        }

        return;
    }

    const listaBeneficios = async () => {
        const resp :AxiosResponse<ListResponseDto<beneficio>> = await getBeneficios()
        if (resp.status === 200) {
            const data: beneficio[] = await resp.data.items;
            let values: selectorTransversal[] = [];
            data.map((x) => values.push({ value: (x.codigo), label: x.descripcion }));
            setBeneficios(values);
        }

        return;
    }

    const obtenerOperacion = async (idMutuo: number) => {
        const resp: AxiosResponse = await getOperacion(idMutuo);
        if (resp.status !== StatusCode.Ok) return;

        const data: operacion = await resp.data;

        setDefaultValues(data);

        return;
    }

    const listaValuesDominio = async (dominio: Dominios) => {
        const resp: AxiosResponse<ListResponseDto<selectorTransversal>> = await getValoresDominio(dominio)
        if (resp.status !== StatusCode.Ok) return;
        const data: selectorTransversal[] = await resp.data.items;
        switch (dominio) {
            case Dominios.UTILIDAD:
                setUtilidades(data);
                break;
            case Dominios.CANAL_VENTA:
                setCanalVentas(data);
                break;
            case Dominios.PREPAGO:
                setPrepagos(data);
                break;
            case Dominios.DFL2:
                setDfl2(data);
                break;
            case Dominios.ADQUISICION:
                setAdquisicion(data);
                break;
            case Dominios.REFINANCIAMIENTO:
                setRefinanciamiento(data);
                break;
            default:
                break;
        }
    }

    const listarSelectores = async () => {
        listaTipoProducto();
        listaDestino();
        listaEjecutivo();
        listaOrigen();
        listaFinalidad();
        listaTipoSubsidio();
        listaBeneficios();
        listaValuesDominio(Dominios.CANAL_VENTA);
        listaValuesDominio(Dominios.UTILIDAD);
        listaValuesDominio(Dominios.PREPAGO);
        listaValuesDominio(Dominios.DFL2);
        listaValuesDominio(Dominios.REFINANCIAMIENTO);
        listaValuesDominio(Dominios.ADQUISICION);
    }

    const initSelectorBaseTasas = async () => {

        const resp: AxiosResponse<ListResponseDto<selectorTransversal>> = await getValoresDominio(Dominios.TABLAS_DESARROLLO_BASE_TASA)
        if (resp.status !== StatusCode.Ok) return;

        const valoresSelector: selectorTransversal[] = await resp.data.items;
        setSelectorBaseTasas(valoresSelector);
    }

    const getEmisores = async () => {
        const resp: AxiosResponse = await getEmisoresTablaDividendo();
        if (resp.status !== StatusCode.Ok) return;

        const valoresSelector: selectorTransversal[] = [resp.data];
        setEmisores(valoresSelector);
    }

    return {
        obtenerOperacion,
        listarSelectores,
        getEmisores,
        listaTipoSubsidio,
        adquisicion,
        refinanciamiento,
        tipoProductos,
        listaDestinos,
        listaEjecutivos,
        listaOrigenes,
        finalidades,
        tipoSubsidios,
        beneficios,
        utilidades,
        canalVentas,
        prepagos,
        dfl2,
        defaultValues,
        initSelectorBaseTasas,
        selectorBaseTasas,
        emisores
    }
}
